import { Link } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { AlertTriangle } from "lucide-react";

export function WhatsAppTokenBanner() {
  const {
    subscriptionStatus,
    lang,
    wappTokenReconnectRecommended,
    wappDisconnected,
  } = useAuth();
  const locale = lang === "es" ? "es" : "en";

  if (!wappTokenReconnectRecommended && !wappDisconnected) {
    return null;
  }

  const isDunning = subscriptionStatus === "dunning";
  const topClass = isDunning ? "top-9" : "top-0";

  return (
    <div
      className={`fixed left-0 right-0 z-[100] w-full bg-sky-50 text-sky-950 px-4 py-2 border-b border-sky-200 ${topClass}`}
    >
      <div className="flex items-center justify-center gap-2 max-w-7xl mx-auto text-sm">
        <AlertTriangle className="w-4 h-4 shrink-0 text-sky-600" aria-hidden />
        <span>
          {wappDisconnected
            ? locale === "es"
              ? "Tu WhatsApp se desconectó de Eloria. Vuelve a conectarlo para que Eloria siga respondiendo."
              : "Your WhatsApp was disconnected from Eloria. Reconnect it so Eloria keeps replying."
            : locale === "es"
              ? "Tu conexión de WhatsApp caduca pronto o ya venció. Vuelve a conectarla para seguir enviando mensajes."
              : "Your WhatsApp connection is expiring soon or has expired. Reconnect it to keep sending messages."}
        </span>
        <Link
          to="/settings?tab=assistant"
          className="underline underline-offset-2 hover:text-sky-800 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-offset-1 rounded shrink-0"
        >
          {locale === "es" ? "Ir a configuración" : "Go to settings"}
        </Link>
      </div>
    </div>
  );
}
